import * as types from '../mutation-types'
import axios from "axios";

// state
export const state = {
    all: []
};

// getters
export const getters = {
    all: state => state.all
};

// mutations
export const mutations = {
    [types.BANKS_ALL_SET] (state, data) {
        state.all = data;
    }
};

// actions
export const actions = {
    async fetch(context) {
        await axios.get('/api/banks')
            .then(function (response) {
                context.commit(types.BANKS_ALL_SET, response.data)
            });
    }
};
